<template>
  <header class="header header-6">
    <div class="header-top second-grey-neurohub d-none d-md-block">
      <div class="container">
        <div class="header-left">
          <ul class="top-menu top-link-menu d-none d-md-block">
            <li>
              <a href="#">Links</a>
              <ul>
                <li>
                  <a href="mail:info@vascularclass.com" class="text-dark"><i class="las la-envelope"></i>Email:
                    info@vascularclass.it</a>
                </li>
              </ul>
            </li>
          </ul>
          <!-- End .top-menu -->
        </div>
        <!-- End .header-left -->

        <div class="header-right">
          <!-- End .soial-icons -->
          <ul class="top-menu top-link-menu" v-if="auth">
            <li>
              <a href="#">Links</a>
              <ul>
                <li>
                  <router-link to="/profile" class="text-dark"><i class="icon-user"></i>Il tuo profilo</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <!-- End .top-menu -->
        </div>
        <!-- End .header-right -->
      </div>
    </div>
    <div class="header-middle grey-color-nerohub">
      <div class="container">
        <div class="header-center">
          <router-link to="/dashboard" class="logo">
            <img :src="image" alt="Molla Logo" style="width: 50px !important; height: 70px !important" />
          </router-link>
        </div>
        <!-- End .header-left -->

        <div class="header-right" v-if="auth">
          <div class="dropdown cart-dropdown cart-product-iloveart">
            <button type="button" class="btn btn-link dropdown-toggle" role="button" data-toggle="dropdown"
              aria-haspopup="false" aria-expanded="false" data-display="static" @click="readAt">
              <i class="lar la-bell"></i>
              <span class="cart-count">{{ notificationLenghtRead }}</span>
            </button>

            <div class="dropdown-menu dropdown-menu-right">
              <div style="overflow: hidden; height: 500px">
                <div class="dropdown-cart-products cart-product-iloveart" style="overflow-y: scroll; height: 100%">
                  <div v-if="notifications.length > 0">
                    <div class="product" v-for="notification in notifications" :key="notification.id">
                      <div class="product-cart-details">
                        <h4 class="product-title cart-product-iloveart">
                          <a :href="notification.url">
                            <strong> {{ notification.message }} </strong>
                          </a>
                        </h4>
                      </div>
                      <!-- End .product-cart-details -->
                    </div>
                  </div>
                  <!-- End .product -->

                  <div class="product" v-if="notifications.length == 0">
                    <div class="product-cart-details">
                      <h4 class="product-title cart-product-iloveart">
                        Non ci sono nuove notifiche
                      </h4>
                    </div>
                  </div>
                </div>
                <!-- End .cart-product -->
              </div>
            </div>
            <!-- End .dropdown-menu -->
          </div>
          <div class="mobile-menu-toggler d-md-none">
            <button class="btn btn-link" @click="openMenu">
              <i class="icon-bars text-dark" style="font-size: 25px"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- End .container -->
    </div>
    <!-- End .header-middle -->

    <div class="header-bottom sticky-header">
      <div class="container d-flex d-sm-block d-md-flex justify-content-between">
        <div class="header-center" v-if="auth">
          <nav class="main-nav">
            <ul class="menu sf-arrows">
              <li>
                <router-link to="/dashboard">Home</router-link>
              </li>
              <li v-for="(slug, name) in publicpages" :key="slug">
                <a :href="'/vascularclass/' + slug">{{ name }}</a>
              </li>

              <li>
                <router-link to="/casi-clinici">Casi clinici</router-link>
              </li>
              <li>
                <router-link to="/forum">Forum</router-link>
              </li>
              <li>
                <router-link to="/meeting">E-meeting</router-link>
              </li>
              <li>
                <router-link to="/library">Biblioteca</router-link>
              </li>
              <li>
                <router-link to="/presentation">Presentazioni</router-link>
              </li>

              <li v-if="isAdmin">
                <a :href="adminDomain" target="_blank">Amministrazione</a>
              </li>

              <li>
                <!-- <router-link to="/account">Account</router-link> -->
              </li>
            </ul>
            <!-- End .menu -->
          </nav>
          <!-- End .main-nav -->
        </div>
        <!-- End .header-left -->
        <!-- Desktop Menu Burger (Nascondi nella versione mobile) -->
      </div>
      <!-- End .container -->
    </div>
    <!-- End .header-bottom -->
  </header>
  <!-- End .header -->
</template>

<script>
import httpauth from "@/services/httpauth.js";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import { useAuth } from "@/stores/auth.js";
export default {
  name: "NavBarComponent",
  props: ["image", "auth"],
  data() {
    return {
      request: {
        website: "https://vascularclass.it/",
        slug: "login",
      },
      notifications: [],
      notificationLenghtRead: 0,
      publicpages: [],
      adminDomain: "",
      isAdmin: false,
    };
  },
  mounted() {
    this.getPublicPage();
    const auth = useAuth();
    try
    {
      if (auth.user != null)
      {
        this.getNotifications();
        if (auth.user.is_admin)
        {
          const domain = window.location.hostname;
          this.isAdmin = true;
          switch (domain)
          {
            case "localhost":
              this.adminDomain = "http://localhost/admin/login";

              break;
            case "demo.vascularclass.it":
              this.adminDomain =
                "https://test.gestione.vascularclass.it/admin/login";
              break;
            case "vascularclass.it":
            case "www.vascularclass.it":
              this.adminDomain =
                "https://gestione.vascularclass.it/admin/login";
              break;
          }
        }
      }
    } catch (error)
    {
      console.log(error);
      console.log("Errore admin");
    }
  },
  methods: {
    async getPublicPage() {
      await httpauth
        .get("/static-pages/public-page")
        .then((response) => {
          this.publicpages = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async readAt() {
      if (this.notificationLenghtRead > 0)
      {
        await httpauth.get("/notifications/read-at").then(() => {
          this.getNotifications();
        });
      }
    },
    openMenu() {
      $("body").toggleClass("mmenu-active");
      $(this).toggleClass("active");
    },
    async getNotifications() {
      await httpauth
        .get("/notifications")
        .then((response) => {
          this.notifications = response.data.data;
          this.notificationLenghtRead = this.notifications.filter(
            (notification) => notification.read_at == ""
          ).length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
@media (min-width: 1281px) {
  .container-custom {
    display: block !important;
  }
}
</style>